// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hNruH","left":"styles_left__1FuRF","desktopActions":"styles_desktopActions__BPplu","title":"styles_title__3AT47"};